// extracted by mini-css-extract-plugin
export default {"button":"button_button__0On-O","loading":"button_loading__hhPQC","active":"button_active__CmaSd","iconButton":"button_iconButton__TZCBI","delete":"button_delete__GBdjl"};